export const SEARCH_PAGE_VIEW = 'spv';
export const LISTING_PAGE_VIEW = 'lpv';
export const DETAILS_PAGE_VIEW = 'dpv';
export const RESULTS_PAGE = 'results';
export const DETAILS_PAGE = 'details';
export const ALL_CATEGORIES = 'all-categories';
